import React, { useEffect, useState } from "react";
import { Layout } from "..";
import {
  Loader,
  StandingTable,
  TeamInformation,
  TeamScores,
  TeamPlayersSlider,
  TeamStatsTable,
  StatHistory,
} from "../../components";
import { Link } from "react-router-dom";
import { TeamContainer } from "./styled";
import { useLocation } from "react-router-dom";
import { calculatePlayerStats } from "../../lib/cabbStats";
import { UpgradeContainer } from "../../components";
import styles from "../../styles/Home.module.scss";

const TeamProfile = ({ appData }) => {
  const [activeProfile, setActiveProfile] = useState(null);
  const [games, setGames] = useState(null);
  const location = useLocation();
  const [isLoaded, setIsLoaded] = useState(false);
  const [gamesWonByTeam, setGamesWonByTeam] = useState(0);
  const [sortedPlayers, setSortedPlayers] = useState(null);
  const [gamesPlayed, setGamesPlayed] = useState(0);
  const sessionUser = JSON.parse(sessionStorage.getItem("user") || "null");
  const isPremiumUser = sessionUser && sessionUser.plan !== "Basic";
  const [activePhase, setActivePhase] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: "player_number",
    direction: "asc",
  });
  const [activeTab, setActiveTab] = useState(null);
  const [activeSeason, setActiveSeason] = useState(
    process.env.REACT_APP_ACTIVE_SEASON
  );

  const urlParts = location.pathname.split("/");
  let slug = urlParts[2];

  useEffect(() => {
    const fetchData = async () => {
      setIsLoaded(false);
      const activeLeague = appData?.teams
        ?.filter((e) => e._id === slug)[0]
        .history.filter((team) => {
          return team.season === activeSeason;
        })[0]?.league;
      try {
        const response = await fetch(
          `https://deportactico-vercel-serverless.vercel.app/api/gamesByleague?season=${activeSeason}&league=${activeLeague}`
        );
        const result = await response.json();
        setGames(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoaded(true); // Ensure loading is false after fetching
      }
    };

    if (activeSeason) {
      fetchData();
    }
  }, [appData, slug, activeSeason]);

  useEffect(() => {
    if (appData.teams !== null && appData.players !== null && games !== null) {
      let filterTeams = appData?.teams?.filter((e) => e._id === slug);
      setActiveProfile(filterTeams[0]);
      getGamesScore();
      if (filterTeams[0]?.team_primary_color !== undefined) {
        document.documentElement.style.setProperty(
          "--team-primary-color",
          filterTeams[0]?.team_primary_color
        );
        document.documentElement.style.setProperty(
          "--team-secondary-color",
          filterTeams[0]?.team_secondary_color
        );
      }
    }
    if (urlParts.length > 3) {
      setActiveTab(urlParts[3]);
    } else if (urlParts.length === 3) {
      setActiveTab(null);
    }
  }, [
    appData,
    appData.teams,
    appData.players,
    activeProfile,
    games,
    slug,
    activePhase,
    activeSeason,
    urlParts,
  ]);

  const getGamesScore = async () => {
    let gamesFiltered = await games?.filter(
      (game) =>
        (game.local_team === activeProfile?._id ||
          game.visit_team === activeProfile?._id) &&
        game.season === activeSeason &&
        (activePhase === null || game.stage === activePhase)
    );

    let wonGames = 0;
    for (let index = 0; index < gamesFiltered?.length; index++) {
      let localTotalPts = 0;
      let visitTotalPts = 0;
      if (gamesFiltered[index].local_team === activeProfile?._id) {
        gamesFiltered[index].local_stats.forEach((element) => {
          localTotalPts += element.pts;
        });
        gamesFiltered[index].visit_stats.forEach((element) => {
          visitTotalPts += element.pts;
        });
        if (localTotalPts > visitTotalPts) {
          wonGames++;
        }
      } else if (gamesFiltered[index].visit_team === activeProfile?._id) {
        gamesFiltered[index].local_stats.forEach((element) => {
          localTotalPts += element.pts;
        });
        gamesFiltered[index].visit_stats.forEach((element) => {
          visitTotalPts += element.pts;
        });
        if (visitTotalPts > localTotalPts) {
          wonGames++;
        }
      }
    }
    setGamesWonByTeam(wonGames);
    await setGamesPlayed(gamesFiltered.length);
  };

  useEffect(() => {
    if (!appData?.players?.length) return;
    else if (
      activeProfile !== null &&
      games !== null &&
      appData.players !== null
    ) {
      const filteredAndSortedPlayers = appData.players
        .filter((player) => {
          // Verifica si el jugador tiene un historial con la temporada activa
          const isRegisteredInSeason = player.teams_history?.some(
            (item) =>
              item.season === activeSeason &&
              item.teamId === activeProfile?._id &&
              (item.end_date === "active" || item.end_date === undefined)
          );

          // Filtra jugadores que están en el equipo activo o que han jugado en ese equipo en la temporada activa
          return isRegisteredInSeason;
        })
        .sort((a, b) => {
          if (sortConfig.key === "player_number") {
            const numberA = a.player_number
              ? Number(a.player_number)
              : Infinity;
            const numberB = b.player_number
              ? Number(b.player_number)
              : Infinity;

            // Asegúrate de manejar NaN
            if (isNaN(numberA)) return sortConfig.direction === "asc" ? 1 : -1;
            if (isNaN(numberB)) return sortConfig.direction === "asc" ? -1 : 1;

            if (numberA < numberB)
              return sortConfig.direction === "asc" ? -1 : 1;
            if (numberA > numberB)
              return sortConfig.direction === "asc" ? 1 : -1;
            return 0;
          } else if (sortConfig.key === "player_name") {
            const nameA = a.player_name.toUpperCase();
            const nameB = b.player_name.toUpperCase();
            if (nameA < nameB) return sortConfig.direction === "asc" ? -1 : 1;
            if (nameA > nameB) return sortConfig.direction === "asc" ? 1 : -1;
            return 0;
          } else {
            const valueA = calculatePlayerStats(
              games?.filter(
                (game) =>
                  (game.local_team === activeProfile._id ||
                    game.visit_team === activeProfile._id) &&
                  game.season === activeSeason &&
                  (activePhase === null || game.stage === activePhase)
              ),
              a._id,
              sortConfig.key
            );
            const valueB = calculatePlayerStats(
              games?.filter(
                (game) =>
                  (game.local_team === activeProfile._id ||
                    game.visit_team === activeProfile._id) &&
                  game.season === activeSeason &&
                  (activePhase === null || game.stage === activePhase)
              ),
              b._id,
              sortConfig.key
            );
            return sortConfig.direction === "asc"
              ? valueA - valueB
              : valueB - valueA;
          }
        });

      setSortedPlayers(filteredAndSortedPlayers);
    }
  }, [activeProfile, appData.players, games, activeSeason, sortConfig]);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  if (!isLoaded) {
    return <Loader />;
  }
  if (!isPremiumUser) {
    return (
      <Layout isPositionUnset={true}>
        <UpgradeContainer>
          <h2>Herramienta solo para usuarios Premium</h2>
          <p>Actualiza tu suscripción ahora.</p>
          <div className="btns-container">
            <Link className="btn-primary" to="/app/suscriptions">
              Ver suscripciones
            </Link>
          </div>
        </UpgradeContainer>
      </Layout>
    );
  }

  return (
    <Layout isPositionUnset={true}>
      {sessionUser !== undefined &&
      sessionUser !== null &&
      sessionUser?.plan !== "Basic" &&
      activeProfile !== null ? (
        <TeamContainer primaryColor={activeProfile.team_primary_color}>
          <div className="navbar">
            <div className="logo">
              <img src={`/assets/teams-logos/${activeProfile?.name}.png`} />
            </div>
            <div className="navbar-content">
              <h3 className={styles.dynamicHeaderh3}>{activeProfile?.name}</h3>
              <div className="flex_center_space-between header-links-container">
                <ul>
                  <li>
                    <Link
                      className={activeTab === null ? "active" : null}
                      to={`/teamProfile/${slug}`}
                    >
                      Overview
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={activeTab === "estadisticas" ? "active" : null}
                      to={`/teamProfile/${slug}/estadisticas`}
                    >
                      Estadisticas
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={activeTab === "fixture" ? "active" : null}
                      to={`/teamProfile/${slug}/fixture`}
                    >
                      Fixture
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={activeTab === "equipo" ? "active" : null}
                      to={`/teamProfile/${slug}/equipo`}
                    >
                      Equipo
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={activeTab === "historial" ? "active" : null}
                      to={`/teamProfile/${slug}/historial`}
                    >
                      Historial
                    </Link>
                  </li>
                </ul>
                {activeTab !== "historial" ? (
                  <>
                    <select
                      id="phase-select"
                      onChange={(e) => {
                        setActiveSeason(e.target.value);
                        setIsLoaded(false);
                      }}
                      value={activeSeason}
                    >
                      {activeProfile.history
                        .sort((a, b) => {
                          // Extrae el año inicial de cada temporada
                          const startYearA = parseInt(
                            a.season.split("/")[0],
                            10
                          );
                          const startYearB = parseInt(
                            b.season.split("/")[0],
                            10
                          );
                          // Ordena de la más reciente a la más antigua
                          return startYearB - startYearA;
                        })
                        .map((history, index) => (
                          <option key={index}>{history.season}</option>
                        ))}
                    </select>
                    <select
                      id="phase-select"
                      onChange={(e) => {
                        e.target.value !== "Temporada completa"
                          ? setActivePhase(e.target.value)
                          : setActivePhase(null);
                      }}
                    >
                      <option hidden defaultValue>
                        Selecciona Fase
                      </option>
                      <option>Temporada completa</option>
                      <option>Fase regular</option>
                      <option>Play in</option>
                      <option>Reclasificación</option>
                      <option>Playoff</option>
                      <option>Permanencia</option>
                    </select>
                  </>
                ) : null}
              </div>
            </div>
          </div>
          <div className="content">
            {activeTab === null ? (
              <>
                <div className="teamInformation-table-container">
                  <TeamInformation
                    teamId={activeProfile?._id}
                    games={games}
                    activeSeason={activeSeason}
                    activePhase={activePhase}
                  />
                </div>
                <div className="standing-table-container">
                  <StandingTable
                    appData={appData}
                    games={games}
                    league={
                      activeProfile.history.filter((team) => {
                        return team.season === activeSeason;
                      })[0]?.league
                    }
                    zone={activeProfile?.zone}
                    activeSeason={activeSeason}
                    activeTeam={slug}
                  />
                </div>
                <div className="info-scores">
                  {games.filter(
                    (game) =>
                      (game.local_team === activeProfile._id ||
                        game.visit_team === activeProfile._id) &&
                      game.season === activeSeason &&
                      (activePhase === null || game.stage === activePhase)
                  ).length > 0 ? (
                    <TeamScores
                      appData={appData}
                      games={games}
                      isTeamProfile={true}
                      season={activeSeason}
                      activePhase={activePhase}
                      activeTeam={slug}
                    />
                  ) : (
                    <div
                      className="flex_center_center"
                      style={{ textAlign: "center", width: "100%" }}
                    >
                      <h2>No hay información</h2>
                    </div>
                  )}
                </div>
                <div className="players-slider">
                  {activeProfile.history.filter((team) => {
                    return team.season === activeSeason;
                  })[0]?.league !== undefined ? (
                    <TeamPlayersSlider
                      appData={appData}
                      games={games}
                      activeProfile={activeProfile}
                      activeSeason={activeSeason}
                      activePhase={activePhase}
                    />
                  ) : (
                    <div
                      className="flex_center_center"
                      style={{ textAlign: "center", width: "100%" }}
                    >
                      <h2>No hay información</h2>
                    </div>
                  )}
                </div>
                <div className="team-stats-table">
                  <div className="matches-container">
                    <div>
                      <h2>{gamesPlayed}</h2>
                      <p>Partidos</p>
                    </div>
                    <div
                      class="circle-border"
                      style={{
                        background: `${
                          isNaN((gamesWonByTeam / gamesPlayed) * 100)
                            ? `linear-gradient(270deg, gray ${100}%, transparent 50%)`
                            : `linear-gradient(270deg, red ${
                                (gamesWonByTeam / gamesPlayed) * 100
                              }%, transparent 50%)`
                        }`,
                      }}
                    >
                      <div class="circle">
                        <p>
                          {isNaN(
                            Math.round((gamesWonByTeam / gamesPlayed) * 100)
                          )
                            ? 0
                            : Math.round((gamesWonByTeam / gamesPlayed) * 100)}
                        </p>
                      </div>
                      <div className="hover-information">
                        <p>Porcentaje de victorias</p>
                      </div>
                    </div>
                  </div>
                  <div className="stats-table-header">Estadisticas</div>
                  <TeamStatsTable
                    appData={appData}
                    games={games}
                    activeProfile={activeProfile}
                    activeSeason={activeSeason}
                    activePhase={activePhase}
                    gamesPlayed={gamesPlayed}
                  />
                </div>
                <div className="leaders-table">
                  <table>
                    <thead>
                      <tr>
                        <td>eFG</td>
                        <td>Promedio</td>
                      </tr>
                    </thead>
                    <tbody>
                      {appData?.players !== null &&
                        games !== null &&
                        sortedPlayers
                          ?.slice()
                          ?.sort((a, b) => {
                            const valueA = calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              a._id,
                              "eFG"
                            );
                            const valueB = calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              b._id,
                              "eFG"
                            );
                            return valueB - valueA;
                          })
                          .slice(0, 5)
                          .map((player, index) => (
                            <tr>
                              <td>
                                {player.player_name.toUpperCase()}{" "}
                                {player.player_lastname.toUpperCase()}
                              </td>
                              <td className="value">
                                {games !== null
                                  ? calculatePlayerStats(
                                      games.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "eFG"
                                    )
                                  : 0}
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                  <table>
                    <thead>
                      <tr>
                        <td>usg</td>
                        <td>Promedio</td>
                      </tr>
                    </thead>
                    <tbody>
                      {appData?.players !== null &&
                        games !== null &&
                        sortedPlayers !== null &&
                        sortedPlayers
                          ?.slice()
                          ?.sort((a, b) => {
                            const valueA = calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              a._id,
                              "USG"
                            );
                            const valueB = calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              b._id,
                              "USG"
                            );
                            return valueB - valueA;
                          })
                          .slice(0, 5)
                          .map((player, index) => (
                            <tr>
                              <td>
                                {player.player_name.toUpperCase()}{" "}
                                {player.player_lastname.toUpperCase()}
                              </td>
                              <td className="value">
                                {games !== null
                                  ? calculatePlayerStats(
                                      games.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "USG"
                                    )
                                  : 0}
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                  <table>
                    <thead>
                      <tr>
                        <td>2pts</td>
                        <td>Promedio</td>
                      </tr>
                    </thead>
                    <tbody>
                      {appData?.players !== null &&
                        games !== null &&
                        sortedPlayers
                          ?.slice()
                          ?.sort((a, b) => {
                            const valueA = calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              a._id,
                              "TWOOPP"
                            );
                            const valueB = calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              b._id,
                              "TWOOPP"
                            );
                            return valueB - valueA;
                          })
                          .slice(0, 5)
                          .map((player, index) => (
                            <tr>
                              <td>
                                {player.player_name.toUpperCase()}{" "}
                                {player.player_lastname.toUpperCase()}
                              </td>
                              <td className="value">
                                {games !== null
                                  ? calculatePlayerStats(
                                      games.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "TWOOPP"
                                    )
                                  : 0}
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                  <table>
                    <thead>
                      <tr>
                        <td>3pts</td>
                        <td>Promedio</td>
                      </tr>
                    </thead>
                    <tbody>
                      {appData?.players !== null &&
                        games !== null &&
                        sortedPlayers
                          ?.slice()
                          ?.sort((a, b) => {
                            const valueA = calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              a._id,
                              "THREEPP"
                            );
                            const valueB = calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              b._id,
                              "THREEPP"
                            );
                            return valueB - valueA;
                          })
                          .slice(0, 5)
                          .map((player, index) => (
                            <tr>
                              <td>
                                {player.player_name.toUpperCase()}{" "}
                                {player.player_lastname.toUpperCase()}
                              </td>
                              <td className="value">
                                {games !== null
                                  ? calculatePlayerStats(
                                      games.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "THREEPP"
                                    )
                                  : 0}
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                  <table>
                    <thead>
                      <tr>
                        <td>TL mejores</td>
                        <td>Promedio</td>
                      </tr>
                    </thead>
                    <tbody>
                      {appData?.players !== null &&
                        games !== null &&
                        sortedPlayers
                          ?.slice()
                          ?.sort((a, b) => {
                            const valueA = calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              a._id,
                              "FTP"
                            );
                            const valueB = calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              b._id,
                              "FTP"
                            );
                            return valueB - valueA;
                          })
                          .slice(0, 5)
                          .map((player, index) => (
                            <tr>
                              <td>
                                {player.player_name.toUpperCase()}{" "}
                                {player.player_lastname.toUpperCase()}
                              </td>
                              <td className="value">
                                {games !== null
                                  ? calculatePlayerStats(
                                      games.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "FTP"
                                    )
                                  : 0}
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                  <table>
                    <thead>
                      <tr>
                        <td>TL peores</td>
                        <td>Promedio</td>
                      </tr>
                    </thead>
                    <tbody>
                      {appData?.players !== null &&
                        games !== null &&
                        sortedPlayers
                          ?.slice()
                          ?.sort((a, b) => {
                            const valueA = calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              a._id,
                              "FTP"
                            );
                            const valueB = calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              b._id,
                              "FTP"
                            );
                            return valueA - valueB;
                          })
                          .filter((player) => {
                            const value = calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              player._id,
                              "FTP"
                            );
                            return value > 0;
                          })
                          .slice(0, 5)
                          .map((player, index) => (
                            <tr key={index}>
                              <td>
                                {player.player_name.toUpperCase()}{" "}
                                {player.player_lastname.toUpperCase()}
                              </td>
                              <td className="value">
                                {games !== null
                                  ? calculatePlayerStats(
                                      games.filter(
                                        (game) =>
                                          (game.local_team ===
                                            activeProfile._id ||
                                            game.visit_team ===
                                              activeProfile._id) &&
                                          game.season === activeSeason &&
                                          (activePhase === null ||
                                            game.stage === activePhase)
                                      ),
                                      player._id,
                                      "FTP"
                                    )
                                  : 0}
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : activeTab === "fixture" ? (
              <TeamScores
                appData={appData}
                games={games}
                isTeamProfile={true}
                season={activeSeason}
                activePhase={activePhase}
                activeTeam={slug}
              />
            ) : activeTab === "estadisticas" &&
              activeProfile.history.filter((team) => {
                return team.season === activeSeason;
              })[0]?.league !== undefined ? (
              <TeamStatsTable
                appData={appData}
                games={games}
                activeProfile={activeProfile}
                activeSeason={activeSeason}
                activePhase={activePhase}
                gamesPlayed={gamesPlayed}
                gamesWonByTeam={gamesWonByTeam}
                isStatsPage={true}
              />
            ) : activeTab === "estadisticas" &&
              activeProfile.history.filter((team) => {
                return team.season === activeSeason;
              })[0]?.league === undefined ? (
              <div
                className="flex_center_center"
                style={{ textAlign: "center", width: "100%" }}
              >
                <h2>No hay información</h2>
              </div>
            ) : activeTab === "historial" ? (
              <StatHistory appData={appData} activeProfile={activeProfile} />
            ) : activeTab === "equipo" &&
              activeProfile.history.filter((team) => {
                return team.season === activeSeason;
              })[0]?.league ? (
              <div className="team-container">
                <div className="team-header">
                  <p
                    style={{ flexBasis: "5%" }}
                    className={
                      sortConfig.key === "player_number" &&
                      sortConfig.direction === "asc"
                        ? "up-arrow"
                        : sortConfig.key === "player_number" &&
                          sortConfig.direction === "desc"
                        ? "down-arrow"
                        : null
                    }
                    onClick={(e) => handleSort("player_number")}
                  >
                    Nº
                  </p>
                  <p style={{ width: "50px", flexBasis: "auto" }}></p>
                  <p
                    className={
                      sortConfig.key === "player_name" &&
                      sortConfig.direction === "asc"
                        ? "up-arrow"
                        : sortConfig.key === "player_name" &&
                          sortConfig.direction === "desc"
                        ? "down-arrow"
                        : null
                    }
                    onClick={(e) => handleSort("player_name")}
                  >
                    Nombre
                  </p>
                  <p
                    className={
                      sortConfig.key === "eFG" && sortConfig.direction === "asc"
                        ? "up-arrow"
                        : sortConfig.key === "eFG" &&
                          sortConfig.direction === "desc"
                        ? "down-arrow"
                        : null
                    }
                    onClick={(e) => handleSort("eFG")}
                  >
                    eFG
                  </p>
                  <p
                    className={
                      sortConfig.key === "FTP" && sortConfig.direction === "asc"
                        ? "up-arrow"
                        : sortConfig.key === "FTP" &&
                          sortConfig.direction === "desc"
                        ? "down-arrow"
                        : null
                    }
                    onClick={(e) => handleSort("FTP")}
                  >
                    TL%
                  </p>
                  <p
                    className={
                      sortConfig.key === "TWOOPP" &&
                      sortConfig.direction === "asc"
                        ? "up-arrow"
                        : sortConfig.key === "TWOOPP" &&
                          sortConfig.direction === "desc"
                        ? "down-arrow"
                        : null
                    }
                    onClick={(e) => handleSort("TWOOPP")}
                  >
                    2P%
                  </p>
                  <p
                    className={
                      sortConfig.key === "THREEPP" &&
                      sortConfig.direction === "asc"
                        ? "up-arrow"
                        : sortConfig.key === "THREEPP" &&
                          sortConfig.direction === "desc"
                        ? "down-arrow"
                        : null
                    }
                    onClick={(e) => handleSort("THREEPP")}
                  >
                    3P%
                  </p>
                  <p
                    className={
                      sortConfig.key === "USG" && sortConfig.direction === "asc"
                        ? "up-arrow"
                        : sortConfig.key === "USG" &&
                          sortConfig.direction === "desc"
                        ? "down-arrow"
                        : null
                    }
                    onClick={(e) => handleSort("USG")}
                  >
                    USG
                  </p>
                </div>
                {appData?.players !== null &&
                  games !== null &&
                  sortedPlayers !== null &&
                  sortedPlayers.map((player, index) => (
                    <div className="player-container">
                      <p style={{ flexBasis: "5%" }}>{player.player_number}</p>
                      <img src="/assets/user-icon.png" />
                      <p>
                        {player.player_name.toUpperCase()}{" "}
                        {player.player_lastname.toUpperCase()}
                      </p>
                      <p>
                        {games !== null
                          ? calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              player._id,
                              "eFG"
                            )
                          : 0}
                      </p>
                      <p>
                        {games !== null
                          ? calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              player._id,
                              "FTP"
                            )
                          : 0}
                      </p>
                      <p>
                        {games !== null
                          ? calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              player._id,
                              "TWOOPP"
                            )
                          : 0}
                      </p>
                      <p>
                        {games !== null
                          ? calculatePlayerStats(
                              games.filter(
                                (game) =>
                                  (game.local_team === activeProfile._id ||
                                    game.visit_team === activeProfile._id) &&
                                  game.season === activeSeason &&
                                  (activePhase === null ||
                                    game.stage === activePhase)
                              ),
                              player._id,
                              "THREEPP"
                            )
                          : 0}
                      </p>
                      <p>
                        {games !== null &&
                          calculatePlayerStats(
                            games.filter(
                              (game) =>
                                (game.local_team === activeProfile?._id ||
                                  game.visit_team === activeProfile?._id) &&
                                game.season === activeSeason &&
                                (activePhase === null ||
                                  game.stage === activePhase)
                            ),
                            player._id,
                            "USG"
                          )}
                      </p>
                    </div>
                  ))}
              </div>
            ) : activeTab === "equipo" &&
              activeProfile.history.filter((team) => {
                return team.season === activeSeason;
              })[0]?.league === undefined ? (
              <div
                className="flex_center_center"
                style={{ textAlign: "center", width: "100%" }}
              >
                <h2>No hay información</h2>
              </div>
            ) : null}
          </div>
        </TeamContainer>
      ) : null}
    </Layout>
  );
};

export default TeamProfile;
